(function() {
    function GenreFormatter(genreData) {
        return function(genreId) {
            var foundGenre = _.result(
                _.find(genreData, function(o) {
                    return o.ID === genreId;
                }),
                "Name"
            );
            //console.log(foundGenre);
            return foundGenre;
        };
    }
    GenreFormatter.$inject = ["genreData"];
    angular
        .module("cstudioApp.filters")
        .filter("GenreFormatter", GenreFormatter);
})();